import { css } from '@emotion/react';

import { palette } from '../../../../lib/styles/palette';

export default function FraudHead() {
  return (
    <div css={pcNavContainerStyle}>
      <h2>중고나라 사기 통합 조회</h2>
    </div>
  );
}

const pcNavContainerStyle = css`
  display: none;
  @media (min-width: 1024px) {
    display: block;
    list-style: none;
    padding: 13px 20px;
    background-color: ${palette.white};

    h2 {
      font-size: 1.2rem;
      padding: 1.4rem 0;
      border-bottom: 1px solid ${palette.gray6};
    }
  }
`;
